import { Link, useLocation } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面未找到 - 牛牛视频',
    description: '抱歉，你访问的页面不存在或已被移除，请返回牛牛视频首页继续浏览热门影视内容。',
  });

  return (
    <div className="w-full px-4 md:px-8 pt-28 md:pt-36 pb-20 md:pb-28">
      <div className="max-w-2xl mx-auto text-center">
        <p className="text-7xl md:text-9xl font-black text-background-200 select-none">404</p>
        <h1 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">
          页面未找到
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500">
          抱歉，你访问的页面不存在或已被移除。
        </p>
        <p className="mt-1 text-xs text-foreground-400 font-mono break-all">{location.pathname}</p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="h-11 px-6 inline-flex items-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-bold whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-home-5-line" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="h-11 px-6 inline-flex items-center gap-2 rounded-md bg-background-100 hover:bg-background-200 border border-background-200/70 text-foreground-700 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-search-line" />
            去搜索影视
          </Link>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-foreground-500">
          <Link to="/category/tv" className="hover:text-primary-600 transition-colors cursor-pointer">
            电视剧频道
          </Link>
          <Link to="/category/movie" className="hover:text-primary-600 transition-colors cursor-pointer">
            电影频道
          </Link>
          <Link to="/category/variety" className="hover:text-primary-600 transition-colors cursor-pointer">
            综艺频道
          </Link>
        </div>
      </div>
    </div>
  );
}